// Description: This file contains the modal function
const modal = () => {
	// Get all modal triggers
	const modalTriggers = document.querySelectorAll('button[data-modal]');
	const modals = document.querySelectorAll('dialog[data-modal]');
	const toast = document.querySelectorAll('.notification-toast');

	// make the element available to prevent animation on page load
	if (toast !== null) {
		toast.forEach((element) => {
			setTimeout(() => {
				element.classList.add('available');
			}, 1000);
		});
	}

	// If there are modal triggers, loop through them and add event listeners
	modalTriggers &&
	modalTriggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			// When a modal trigger is clicked, get the data-modal attribute value
			const target = trigger.dataset.modal;
			const modal = document.querySelector(`dialog[data-modal="${target}"]`);

			// Find the dialog element with the same data-modal attribute value and show it
			if (modal.classList.contains('notification-toast')) {
				modal.show();
			} else {
				modal.showModal();
			}
		});
	});

	// If there are modals, loop through them and add event listeners
	modals &&
	modals.forEach((modal) => {
		// Add a click event listener to the document
		document.addEventListener('click', (e) => {
			// Check if the click was outside of the dialog
			if (modal === e.target) {
				// Close the dialog
				modal.close();
			}
		});

		modal.querySelector('.close').addEventListener('click', (e) => {
			modal.close();
		});
	});
};

// Export the modal function
export default modal;